import React from "react";
import { Tooltip } from "react-tooltip";
import "./ChaseIqUpgradeTooltip.scss";

const TOOLTIP_CONTENT =
  "ClubReady's new AI-powered product, ChaseIQ, that helps your team understand what's happening in your business and where to focus next.\nReach out to your account manager to experience the power of ChaseIQ.";

const ChaseIqUpgradeTooltip = ({ anchorSelect, isOpen, setIsOpen }) => {
  const controlled = isOpen !== undefined;
  const modeProps = controlled
    ? { isOpen, setIsOpen, openEvents: {}, closeEvents: {} }
    : { openOnClick: true, openEvents: { click: true } };

  return (
    <Tooltip
      place="top"
      className="chaseiq-upgrade-tooltip"
      anchorSelect={anchorSelect}
      content={TOOLTIP_CONTENT}
      globalCloseEvents={{ clickOutsideAnchor: true }}
      {...modeProps}
    />
  );
};

export default ChaseIqUpgradeTooltip;
